import { apiGet } from './client';
import { AuditLogRow } from '../types/Monitoring';

export function getAuditLog(
  fromDate?: string,
  toDate?: string,
  resourceCode?: string,
): Promise<AuditLogRow[]> {
  const params = new URLSearchParams();
  if (fromDate) params.set('fromDate', fromDate);
  if (toDate) params.set('toDate', toDate);
  if (resourceCode) params.set('resourceCode', resourceCode);
  const qs = params.toString();
  return apiGet<AuditLogRow[]>(`/api/audit-log${qs ? '?' + qs : ''}`);
}
